import { render, staticRenderFns } from "./UcPropertyValidityCard.yaml?vue&type=template&id=3ab7fdc4&component"
import script from "./UcPropertyValidityCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcPropertyValidityCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports